<!--
  ~ Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
  ~ This software is the proprietary information of NEXTWELL INTL SRL.
  ~ Use is subject to license and non-disclosure terms
  -->
<p-floatLabel variant="on">
  @if (form) {
    <bs-autocomplete
      bsFloatLabelCompat
      inputId="autocomplete"
      [ngModel]="form.value"
      (ngModelChange)="form.setValue($event)"
      [items]="results"
      [dropdown]="true"
      [disabled]="disabled"
      [displayWith]="getDisplayName"
      [compareWith]="compareByUuid"
      [containerClass]="'full-width'"
      [ngClass]="{'ng-invalid': form.invalid, 'ng-valid': form.valid, 'ng-dirty': dirty }"
      (queryChange)="onQueryChange($event)"
      (selected)="onSelectItem($event)" data-testid="value-autocomplete">
      <ng-template bsItem let-person>
        @if (person) {
          <div class="row">
            <div class="col-12 mb-xs">
              <h6>{{ person.name }}</h6>
            </div>
            <div class="col-12 mb-xs color-gray">
              <span>{{ 'person.idSeries' | translate }}: {{ person.idSeries | displayNullValue }}</span>
            </div>
            <div class="col-12 color-gray">
              <span>{{ 'person.idNumber' | translate }}: {{ person.idNumber | displayNullValue }}</span>
            </div>
          </div>
        }
      </ng-template>
    </bs-autocomplete>
  }

  @if (placeholder) {
    <label for="autocomplete">{{ placeholder }}</label>
  }
</p-floatLabel>



